<template>
<div>
    <div class="main-header">
        <div class="container">
            <h2 class="main-header-text">Security Phrase</h2>
        </div>
    </div>
    <div class="main-section mgt-40">
        <div class="container">
            <div class="main-card">
                <img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />
                <div class="phrase-content security-phrase">
                    <div class="content-inner">
                        <div class="sp-section">
                            <h6>Anti-Phishing </h6>
                            <p>To better protect you, we're implementing an additional security verification before logging into your account. </p>
                        </div>
                        <div class="sp-section">
                            <h6>Security Phrase </h6>
                            <p>Enter a phrase only you would know (30 character limit). This phrase will appear on the login screen once the Username is entered.</p>
                        </div>
                        <div class="sp-section form-group">
                            <label>Insert your phrase here :</label>
                            <input autocomplete="off" id="passphrase" v-model="vModel.passphrase" v-validate="'required|min:8|max:30'" data-vv-as='Phrase' v-drag-disable='' :class="{'input': true, 'is-danger': errors.has('passphrase'),'form-control' : true  }" type="text" placeholder="Insert Your Phrase" name="passphrase" v-only-uppercase />
                            <div v-show="errors.has('passphrase')" class="help is-danger">
                                {{ errors.first('passphrase') }}</div>
                        </div>
                        <div class="sp-section">
                            <h6>Note : </h6>
                            <p> Please enter a phrase that is easily remembered. DO NOT <br> insert your User ID or Password as Security Phrase. </p>
                        </div>
                        <div class="button-wrap ">
                            <button class="btn btn-next" type="button" @click="$parent.onPassPhraseSubmit">Next</button>
                        </div>
                    </div>
                    <!--end Content inner-->
                </div>
                <!--end content-->
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "passphraseinput",
    props: ["vModel"],
    inject: ['$validator'],
    watch: {
        "vModel.passphrase": function (newvalue, oldvalue) {
            this.vModel.passphrase=newvalue;
            
        }
    },
}
</script>
